import React, { useEffect } from 'react'
import TableLayout from '../../components/TableLayout'
import Search from '../../components/Search'
import { Col, Row, Form, Select } from 'antd'

const current = JSON.parse(localStorage.getItem('sucursal'))

const damagedOptions = [
    {
        value: null,
        name: 'Ninguno',
    },
    {
        value: 0,
        name: 'No dañados',
    },
    {
        value: 1,
        name: 'Dañados',
    },
    {
        value: 2,
        name: 'Todos',
    },
]

const ReportInventoryContainer = props => {
    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
    })
    const [damagedFilter, setDamagedFilter] = React.useState(damagedOptions[0])

    const columns = [
        {
            title: 'SKU',
            dataIndex: 'product.sku',
            sorter: true,
            filtered: true,
        },

        {
            title: 'Código de barras',
            dataIndex: 'product.barcode',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Producto',
            dataIndex: 'product.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Marca',
            dataIndex: 'product.brand.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Cantidad',
            dataIndex: 'quantity',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Perdidos',
            dataIndex: 'missing',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Dañados',
            dataIndex: 'damaged',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Maximo',
            dataIndex: 'max',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Minimo',
            dataIndex: 'min',
            sorter: true,
            filtered: true,
        },
    ]

    return (
        <>
            <TableLayout
                title="Reporte de inventario"
                columns={columns}
                resource={`inventory/product/search`}
                params={`&filter[subsidiary_id]=${subsidiary.id}`}
                actions={['excel', 'pdf']}
                additionalFilter={
                    <Row gutter={24}>
                        <Col lg={6} md={12} sm={12}>
                            <Form.Item label="Sucursal">
                                <Search
                                    value={subsidiary.name}
                                    placeholder="Sucursal"
                                    onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                    onChange={(key, value) => {
                                        setSubsidiary(value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        {/* <Col lg={6} md={12} sm={12}>
                            <Form.Item label="Dañados">
                                <Select
                                    value={damagedFilter.name}
                                    placeholder="Dañados"
                                    filterOption={false}
                                    onSearch={value => {
                                        return `/api/subsidiaries?filter[damaged]=${value}`
                                    }}
                                    onChange={(value) => {
                                        setDamagedFilter(damagedOptions[value])
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    {damagedOptions.map(p => (
                                        <Select.Option key={p.value}>{p.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col> */}
                    </Row>
                }
            />
        </>
    )
}

export default ReportInventoryContainer
